import styled from '@emotion/styled'
import { Paper } from '@mui/material'
import { APP_TOP_INDENT } from '../../constants/app.indents'

export const BlockWrapper = styled(Paper)(({ theme }) => ({
    height: `calc(100dvh - ${APP_TOP_INDENT}px)`,
    backgroundColor: '#fff',
    ...theme.typography.body2,
    color: theme.palette.text.secondary,
    ...theme.applyStyles('dark', {
        backgroundColor: '#1A2027',
    }),
    [theme.breakpoints.down('sm')]: {
        height: '100%',
    },
}))
